<template>
    <div class="engine">
        <div id="topbar">
            <router-link to="/aesthetics" class="topbar-link topbar-link-back">
                <i class="fas fa-angle-left"></i>
                Back to Aesthetics
                <div class="skew-border skew-border-right"></div>
            </router-link>

            <div class="topbar-link topbar-link-forward cursor" v-on:click="changeToNextFeature()">
                {{ forward_button_text }}
                <i class="fas fa-angle-right"></i>
                <div class="skew-border skew-border-left"></div>
            </div>

            <div class="topbar-link topbar-link-features cursor" v-on:click="toggleFeatureList()">
                <i class="fas fa-angle-down" v-if="!showFeatureList"></i>
                <i class="fas fa-angle-up" v-if="showFeatureList"></i>
                <span id="active-feature">{{ activeFeature.index + ". " + activeFeature.name }}</span>
                <div class="skew-border skew-border-right border-black"></div>
            </div>

            <div v-if="showFeatureList" id="feature-list">
                <ul v-for="(item, index) in features">
                    <li v-on:click="changeActiveFeature(item)" class="cursor">
                        <span class="feature-number">{{ index + 1 + "." }}</span>
                        {{ item.name }}
                        <span class="check-mark" v-bind:class="{ featureChecked: featureCheckStatus[index] }">
                            <i class="fas fa-check"></i>
                        </span>
                    </li>
                </ul>
            </div>
        </div>

        <div id="sidebar" :style="sidebar_position">
            <div id="sidebar-toggle" v-on:click="toggleSidebar()" class="cursor">
                <i class="fas fa-angle-left" v-if="!sidebarActive"></i>
                <i class="fas fa-angle-right" v-if="sidebarActive"></i>
            </div>
            <div id="sidebar-content">
                <p>
                    Select your {{ activeFeature.name }}
                </p>
                <ul v-if="activeFeature.index === 1">
                    <li v-for="engine in engines" class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeEngine(engine)"
                        v-bind:class="{ sidebarFeatureActive: engine.name === $root.$data.features.engine.name }"
                    v-if="$root.$data.aesthetics.model_size.slug === 'damsko-'+engine.model">
                        <div class="unskew">
                            <img :src="engine.image">
                            <span class="feature-item-name">
                            {{ engine.name }}
                        </span>
                            <p class="feature-item-details">
                                {{ engine.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(engine)" v-if="engine.info">i</span>
                        </div>
                    </li>
                </ul>
                <p class="cabin-message" v-if="activeFeature.index === 2">Extend your weekend getaway with a cabin that’s equipped with beds or an optional toilet
                    or go crazy and do both. This way you get the most out of your boating experience.
                    No reason to stress or worry where to stay and no need to rush back to shore. Bonus,
                    it also features lots of storage space. Because you got it, comfort should never be overlooked.
                </p>
                <ul v-if="activeFeature.index === 2 && $root.$data.aesthetics.cabin_style.slug === 'cabin'">
                    <li v-for="(cabin, index) in cabins" class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeCabin(cabin, index)"
                        v-bind:class="{ sidebarFeatureActive: cabin_active[index] }">
                        <div class="unskew">
                            <img :src="cabin.image">
                            <span class="feature-item-name">
                            {{ cabin.name }}
                        </span>
                            <p class="feature-item-details">
                                {{ cabin.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(cabin)" v-if="cabin.info">i</span>
                        </div>
                    </li>
                </ul>
                <p v-if="activeFeature.index === 2 && !($root.$data.aesthetics.cabin_style.slug === 'cabin')" class="cabin-message">
                    No options available, because you didn't choose a cabin model. Please go back to Aesthetics and change your deck style in order to make a choice for this category.<br>
                    <router-link to="/">Back to Aesthetics</router-link>
                </p>
                <ul v-if="activeFeature.index === 3">
                    <li v-for="anchor_system in anchor_systems" class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeAnchorSystem(anchor_system)"
                        v-bind:class="{ sidebarFeatureActive: anchor_system.name === $root.$data.features.anchor_system.name }">
                        <div class="unskew">
                            <img :src="anchor_system.image">
                            <span class="feature-item-name">
                            {{ anchor_system.name }}
                        </span>
                            <p class="feature-item-details">
                                {{ anchor_system.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(anchor_system)" v-if="anchor_system.info">i</span>
                        </div>
                    </li>
                </ul>
                <ul v-if="activeFeature.index === 4">
                    <li v-for="roofing in roofings" class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeRoofing(roofing)"
                        v-bind:class="{ sidebarFeatureActive: roofing.name === $root.$data.features.roofing.name }">
                        <div class="unskew">
                            <img :src="roofing.image">
                            <span class="feature-item-name">
                            {{ roofing.name }}
                        </span>
                            <p class="feature-item-details">
                                {{ roofing.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(roofing)" v-if="roofing.info">i</span>
                        </div>
                    </li>
                </ul>
                <ul v-if="activeFeature.index === 5">
                    <li v-for="navigation in navigations" class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeNavigation(navigation)"
                        v-bind:class="{ sidebarFeatureActive: navigation.name === $root.$data.features.navigation.name }">
                        <div class="unskew">
                            <img :src="navigation.image">
                            <span class="feature-item-name">
                            {{ navigation.name }}
                        </span>
                            <p class="feature-item-details">
                                {{ navigation.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(navigation)" v-if="navigation.info">i</span>
                        </div>
                    </li>
                </ul>
                <ul v-if="activeFeature.index === 6">
                    <li v-for="deck_flooring in deck_floorings" class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeDeckFlooring(deck_flooring)"
                        v-bind:class="{ sidebarFeatureActive: deck_flooring.name === $root.$data.features.deck_flooring.name }">
                        <div class="unskew">
                            <img :src="deck_flooring.image">
                            <span class="feature-item-name">
                            {{ deck_flooring.name }}
                        </span>
                            <p class="feature-item-details">
                                {{ deck_flooring.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(deck_flooring)" v-if="deck_flooring.info">i</span>
                        </div>
                    </li>
                </ul>
                <ul v-if="activeFeature.index === 7">
                    <li v-for="bow_thruster in bow_thrusters" class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeBowThruster(bow_thruster)"
                        v-bind:class="{ sidebarFeatureActive: bow_thruster.name === $root.$data.features.bow_thruster.name }">
                        <div class="unskew">
                            <img :src="bow_thruster.image">
                            <span class="feature-item-name">
                            {{ bow_thruster.name }}
                        </span>
                            <p class="feature-item-details">
                                {{ bow_thruster.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(bow_thruster)" v-if="bow_thruster.info">i</span>
                        </div>
                    </li>
                </ul>
                <ul v-if="activeFeature.index === 8">
                    <li v-for="audio in audios" class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeAudio(audio)"
                        v-bind:class="{ sidebarFeatureActive: audio.name === $root.$data.features.audio.name }">
                        <div class="unskew">
                            <img :src="audio.image">
                            <span class="feature-item-name">
                            {{ audio.name }}
                        </span>
                            <p class="feature-item-details">
                                {{ audio.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(audio)" v-if="audio.info">i</span>
                        </div>
                    </li>
                </ul>
                <ul v-if="activeFeature.index === 9">
                    <li v-for="(lighting, index) in lightings" class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeLighting(lighting, index)"
                        v-bind:class="{ sidebarFeatureActive: lighting_active[index] }">
                        <div class="unskew">
                            <img :src="lighting.image">
                            <span class="feature-item-name">
                            {{ lighting.name }}
                        </span>
                            <p class="feature-item-details">
                                {{ lighting.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(lighting)" v-if="lighting.info">i</span>
                        </div>
                    </li>
                </ul>
                <ul v-if="activeFeature.index === 10">
                    <li v-for="(boat_gadget, index) in boat_gadgets"
                        class="feature-list-item sidebar-feature-active cursor"
                        v-on:click="changeBoatGadgets(boat_gadget, index)"
                        v-bind:class="{ sidebarFeatureActive: boat_gadget_active[index] }">
                        <div class="unskew">
                            <img :src="boat_gadget.image">
                            <span class="feature-item-name">
                                    {{ boat_gadget.name }}
                                </span>
                            <p class="feature-item-details">
                                {{ boat_gadget.details }}
                            </p>
                            <span class="info-button" @click.stop="showInfoOverlay(boat_gadget)" v-if="boat_gadget.info">i</span>
                        </div>
                    </li>
                </ul>
                <div id="sidebar-footer">
                    <router-link to="/aesthetics" class="sidebar-footer-button" id="change-model-button">
                        Change model
                    </router-link>
                    <a v-bind:href="more_info_links[activeFeature.index-1]"
                       v-if="more_info_links[activeFeature.index-1]" target="_blank"
                       class="sidebar-footer-button" id="more-info-button">
                        More information
                    </a>
                </div>
            </div>
            <div id="info-overlay" v-if="info_modal_active" v-on:click="info_modal_active = false">
                <div id="info-overlay-content" v-on:click.stop>
                    <p id="info-overlay-content-title">{{ info_modal_title }}</p>
                    <p id="info-overlay-content-text"><span v-html="info_modal_text"></span>
                        <a :href=more_info_links[activeFeature.index-1]
                           target="_blank">{{ more_info_links[activeFeature.index-1] }}</a></p>
                    <i class="fas fa-times cursor" v-on:click="info_modal_active = false"></i>
                </div>
            </div>
        </div>

        <div id="preview-section">
            <div id="boat-preview" style="min-height: calc(100vh - 51px)">
                <img :src="batman_preview"
                     :style="{ left: preview_margin, width: batman_preview_width, transform: 'scale('+zoomLevel+') translate('+ preview_translation +', -50%)'}">
            </div>
            <div id="zoom">
                <i class="fas fa-plus cursor" v-on:click="zoomIn()"></i>
                <i class="fas fa-minus cursor" v-on:click="zoomOut()"></i>
            </div>
        </div>

        <router-link to="/aesthetics" id="view-boat-link">
            <img :src="boat_thumbnail">
            <p>
                View your boat
            </p>
        </router-link>

        <div id="summary-modal" v-if="showSummary" v-on:click="toggleSummary()">
            <div id="summary-list-container" v-on:click.stop>
                <div id="summary-modal-title">
                    <div class="unskew-title">Summary</div>
                </div>
                <ul id="summary-list" v-if="summary_content === 'list'">
                    <li v-for="(value, key) in $root.$data.features" class="flex-container">
                        <div class="summary-name-wrapper flex-item">
                            <p id="summary-item-name">{{ key.replace('_', ' ') }}</p>
                        </div>
                        <div class="summary-details-wrapper flex-item">
                            <p id="summary-item-details" v-if="value.name">{{ value.name }}</p>
                            <p id="summary-item-details" v-else v-for="item in value">{{ item.name }}</p>
                        </div>
                    </li>
                </ul>

                <div class="download-form" v-if="summary_content === 'download'">
                    <div class="download-form-content" v-if="!email_sent">
                        <p>Fill your details in below and you can download a summary of your custom made Lekker Damsko,
                            including a list of all the options you chose with a picture. If you want to get in touch
                            with us don’t hesitate, mail info@lekkerboats.com or call +31 641280833.</p>
                        <form v-on:submit.prevent="downloadPDF()">
                            <input type="email" name="email" v-model="client_email" placeholder="your email" required><br>
                            <input class="send-pdf cursor" v-bind:class="{disabled: !send_button_active}"
                                   v-bind:disabled="!send_button_active" type="submit" value="Send">
                        </form>
                    </div>
                    <div class="loading-spinner" v-if="!send_button_active">
                        <div class="spinner-content">
                            <i class="fas fa-circle-notch fa-spin"></i>
                            <p>sending...</p>
                        </div>
                    </div>
                    <div class="mail-sent-content" v-if="email_sent">
                        <i class="fas fa-check-circle"></i>
                        <p>Your boat configuration PDF has been sent to {{ client_email }}.</p>
                    </div>

                    <div class="close-download-content" v-on:click="summary_content = 'list'">
                        <i class="fas fa-times"></i>
                    </div>
                </div>

                <div class="download-form" v-if="summary_content === 'custom'">
                    <div class="download-form-content" v-if="!custom_sent">
                        <p>Fill out your details below and you’ll receive a summary of your tailor made Damsko
                            including a picture. We’ll get in touch with you to regarding the Damsko you configured.
                            Supplying you with further information regarding the price and who knows maybe even book
                            a potential test ride so you experience the Damsko first hand outside the virtual world.</p>
                        <form v-on:submit.prevent="orderCustom()">
                            <input type="text" name="name" v-model="custom_name" placeholder="your name" required><br>
                            <input type="email" name="email" v-model="custom_email" placeholder="your email" required><br>
                            <input type="tel" name="tel" v-model="custom_tel" placeholder="your telephone number" required>
                            <input class="send-pdf cursor" v-bind:class="{disabled: !send_button_active}"
                                   v-bind:disabled="!send_button_active" type="submit" value="Send">
                        </form>
                    </div>
                    <div class="loading-spinner" v-if="!send_button_active">
                        <div class="spinner-content">
                            <i class="fas fa-circle-notch fa-spin"></i>
                            <p>sending...</p>
                        </div>
                    </div>
                    <div class="mail-sent-content" v-if="custom_sent">
                        <i class="fas fa-check-circle"></i>
                        <p>Thanks for your interest in a custom order.
                            We will get in touch with you.
                            Your boat configuration PDF has been sent to {{ custom_email }}.</p>
                    </div>

                    <div class="close-download-content" v-on:click="summary_content = 'list'">
                        <i class="fas fa-times"></i>
                    </div>
                </div>

                <div id="download-pdf" class="summary-button cursor" v-on:click="summary_content = 'download'" v-if="summary_content === 'list'">
                    <div class="unskew-button">Download PDF</div>
                </div>
                <div id="order-custom" class="summary-button cursor" v-on:click="summary_content = 'custom'" v-if="summary_content === 'list'">
                    <div class="unskew-button">More info about your Damsko</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    .loading-spinner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 1);
        text-align: center;
        .spinner-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        i {
            font-size: 60px;
            margin-top: 25%;
            margin-bottom: 20px;
            color: #c72727;

        }
    }
    
    .download-form {
        width: 100%;
        height: 100%;
        .download-form-content {
            text-align: center;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50% ,-50%);
            form {
                margin-top: 50px;
                input {
                    min-width: 300px;
                    padding: 15px 15px;
                    font-size: 18px;
                    border: 1px solid #000000;
                    background-color: #ffffff;
                    max-width: 100%;
                    margin-bottom: 20px;
                }
                .send-pdf {
                    padding: 10px 100px;
                    color: white;
                    background: #c72727;
                    border: none;
                    transform: skew(-7deg);
                    display: inline-block;
                    font-size: 16px;
                    margin: 50px auto;
                }
                .disabled {
                    opacity: 0.6;
                }
            }
        }

        .mail-sent-content {
            text-align: center;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50% ,-50%);
            i {
                font-size: 60px;
                color: green;
                margin-bottom: 20px;
            }
        }

        .close-download-content {
            position: absolute;
            top: 40px;
            right: 40px;
            font-size: 50px;
        }
    }

    .flex-container {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .flex-item {
            width: 50%;
        }
    }

    .cabin-message {
        font-size:16px !important;
        color: #505050 !important;
        font-weight: 300 !important;
        a {
            display: inline-block;
            color: white;
            padding: 12px 10px;
            font-size: 13px;
            margin: 10px 0;
            background: black;
        }
    }

    #summary-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(128, 128, 128, 0.7);
        z-index: 99999;
        color: black;
        #summary-modal-title {
            background: black;
            color: white;
            transform: skew(-7deg);
            position: absolute;
            top: -56px;
            left: 3px;
            .unskew-title {
                transform: skew(7deg);
                text-align: center;
                padding: 15px 308px;
                font-size: 22px;
            }
        }
        #summary-list-container {
            background: white;
            position: absolute;
            top: 50%;
            left: 50%;
            width: 710px;
            height: 50%;
            transform: translate(-50%, -50%);
            box-shadow: 5px 9px 15px #333333;
            #summary-list {
                margin: 20px 40px;
                list-style-type: none;
                height: 90%;
                overflow: auto;
                padding-right: 20px;
                li {
                    padding: 25px 0;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                    #summary-item-name {
                        text-transform: capitalize;
                        font-size: 22px;
                        display: inline-block;
                        width: 100%;
                    }
                    #summary-item-details {
                        float: right;
                        font-size: 16px;
                        font-weight: 300;
                        display: inline-block;
                        width: 100%;
                        text-align: right;
                    }
                }
            }
            .summary-button {
                position: absolute;
                bottom: -80px;
                color: white;
                transform: skew(-7deg);
                .unskew-button {
                    transform: skew(7deg);
                    padding: 10px 0;
                }
            }
            #download-pdf {
                background: black;
                left: 4px;
                padding-left: 100px;
                padding-right: 100px;
            }
            #order-custom {
                background: #D0021B;
                right: 4px;
                color: white;
                padding-left: 100px;
                padding-right: 100px;
            }
        }
    }

    .featureChecked {
        color: green !important;
    }

    #zoom {
        position: absolute;
        top: calc(50vh - 71px);
        left: 20px;
        i {
            display: block;
            font-size: 30px;
            transform: skew(-7deg);
            margin: 20px 0;
        }
    }

    #view-boat-link {
        position: absolute;
        bottom: 50px;
        left: 30px;
        img {
            height: 50px;
            background: white;
            border: 1px solid black;
            transform: skew(-7deg);
        }
        p {
            font-size: 11px;
            text-align: center;
            color: rgba(0, 0, 0, 0.75);
        }
    }

    #preview-section {
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(52, 52, 52, 0.37));
        z-index: 0;
        #boat-preview {
            img {
                position: fixed;
                top: 50%;
                display: block;
                bottom: 0;
                /*max-height: calc(100vh - 51px);*/
                transition: width 0.5s, transform 0.5s, left 0.5s;
                transform-origin: 0% 0%;
            }
        }
    }

    #sidebar {
        width: 600px;
        height: calc(100vh - 51px);
        background: rgb(230, 230, 230);
        position: fixed;
        display: block;
        right: -600px;
        bottom: 0;
        transition: right 0.5s;
        z-index: 5;

        #sidebar-toggle {
            position: absolute;
            width: 60px;
            left: -60px;
            top: calc(50vh - 100px);
            background: rgba(0, 0, 0, 0.7);
            color: white;
            text-align: center;

            i {
                padding: 11px 8px;
                font-size: 40px;
            }
        }

        #sidebar-heading {
            background: black;
            padding: 15px 0;
            text-align: center;
            transform: skew(-7deg);
            margin-left: 3px;
            h3 {
                transform: skew(7deg);
                font-family: "Roboto", sans-serif;
                font-weight: 500;
                color: white;
            }
        }

        #sidebar-content {
            margin: 20px 40px;
            padding-bottom: 50px;
            color: black;
            height: 80%;
            overflow: auto;

            .feature-list-item {
                transform: skew(-7deg);
                position: relative;
                list-style: none;
                margin: 0 20px 30px 25px;
                padding: 25px;
                background: white;
                border: none;
                min-height: 130px;
                img {
                    height: 100px;
                    margin-right: 10px;
                    float: left;
                }
                .feature-item-name {
                    line-height: 25px;
                    width: 300px;
                }
                .feature-item-details {
                    font-weight: lighter;
                    font-size: 16px;
                    margin-bottom: 0;
                }
                .info-button {
                    position: absolute;
                    top: -15px;
                    right: -15px;
                    padding: 0 8px;
                    border: 1px solid black;
                    border-radius: 100%;
                }
                .unskew {
                    transform: skew(7deg);
                }
            }

            p {
                margin: 30px 0;
                font-size: 20px;
                color: black;
            }

            .sidebarFeatureActive {
                border-bottom: 3px solid #D0021B !important;
                padding-bottom: 22px !important;
            }
        }

        #info-overlay {
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.9);
            width: 100%;
            height: 100%;
            z-index: 99999;
            #info-overlay-content {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: white;
                padding: 35px;
                width: 70%;
                color: black;
                box-shadow: 5px 9px 15px #333333;
                #info-overlay-content-title {
                    font-size: 22px;
                    margin-bottom: 20px;
                    font-weight: 500;
                }
                #info-overlay-content-text {
                    font-size: 15px;
                    font-weight: 300;
                    line-height: 24px;
                    a {
                        color: #C72727 !important;
                    }
                }
                i {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    font-size: 20px;
                }
            }
        }

        #sidebar-footer {
            position: absolute;
            width: 100%;
            bottom: 0;
            left: 0;
            .sidebar-footer-button {
                display: inline-block;
                width: 280px;
                padding: 12px 10px;
                text-align: center;
                color: white;
                font-size: 13px;
            }
            #change-model-button {
                background: black;
            }
            #change-model-button::after {
                position: absolute;
                top: 0;
                left: 280px;
                content: '';
                width: 0;
                height: 0;
                border-top: 40px solid rgba(0, 0, 0, 1);
                border-right: 5px solid transparent;
            }
            #more-info-button {
                float: right;
                background: rgba(0, 0, 0, 0.7);
            }
            #more-info-button::after {
                position: absolute;
                top: 0;
                right: 280px;
                content: '';
                width: 0;
                height: 0;
                border-bottom: 39px solid rgba(0, 0, 0, 0.7);
                border-left: 5px solid transparent;
            }
        }
    }

    #feature-list {
        z-index: 1000;
        position: absolute;
        top: 50px;
        right: 275px;
        background: rgba(0, 0, 0, 0.9);
        padding: 10px 20px;
        ul {
            list-style-type: none;
            li {
                padding: 10px 0 10px 0;
                color: white;
                text-transform: uppercase;
                border-bottom: 1px solid rgba(204, 204, 204, 0.3);
                font-size: 13px;
            }
        }
        .feature-number {
            padding: 10px 10px;
        }

        .check-mark {
            color: rgba(0, 0, 0, 0);
            float: right;
            padding-left: 40px;
        }
    }

    #feature-list::after {
        position: absolute;
        top: 1px;
        right: -53px;
        content: '';
        line-height: 0;
        width: 0;
        height: 0;
        border-top: 380px solid rgba(0, 0, 0, 0.9);
        border-right: 53px solid transparent;

    }

    #topbar {
        position: relative;
        padding-bottom: 50px;
        border-bottom: 1px solid rgb(204, 204, 204);
        background: white;
        z-index: 999;

        #feature-selection-button {
            display: inline;
            top: 0;
            right: 0;
        }

        .topbar-link {
            position: absolute;
            color: #000;
            padding: 15px 20px;
            border: 1px solid rgb(204, 204, 204);
        }

        .topbar-link-back {
            top: 0;
            left: 0;
            border-right: none;
            i {
                margin-right: 20px;
            }
        }

        .topbar-link-forward {
            top: 0;
            right: 0;
            border-left: none;
            padding: 15px 50px;
            i {
                margin-left: 20px;
            }
        }

        .topbar-link-features {
            top: 0;
            right: 222px;
            width: 295px;
            border: 1px solid black;
            border-right: none;
            background: black;
            color: white;
            padding: 11px 20px 12px 20px;
            text-transform: uppercase;
            i {
                padding: 5px 20px 5px 10px;
                margin-right: 10px;
                border-right: 1px solid rgba(255, 255, 255, 0.5);
            }
            #active-feature {
                padding-left: 20px;
            }
        }

        .skew-border {
            display: inline-block;
            position: absolute;
            width: 10px;
            height: 51px;
            transform: skew(-7deg);
            border: 1px solid rgb(204, 204, 204);
        }

        .skew-border-right {
            top: -1px;
            right: -4px;
            border-left: none;
        }

        .skew-border-left {
            top: -1px;
            left: -4px;
            border-right: none;
            border-left: none;
        }

        .border-black {
            right: -3px;
            border: none;
            background-color: black;
        }
    }

</style>

<script>
    // @ is an alias to /src
    export default {
        name: 'features',
        components: {},
        data: function () {
            return {

                summary_content: 'list',

                showSummary: false,

                activeFeature: {
                    name: "Engine",
                    index: 1,

                },
                showFeatureList: false,
                sidebarActive: false,

                featureCheckStatus: [
                    false, false, false, false, true, true, false, false, true, true,
                ],

                preview_translation: '-50%',
                preview_margin: '50%',

                zoomLevel: 1,
                zoomLevelMax: 1.5,
                zoomLevelMin: 0.6,
                zoomLevelStep: 0.1,
                lighting_active: [false, false, false],
                boat_gadget_active: [false, false, false, false, false, true],
                cabin_active: [false, false],

                features: require('../assets/json/feature-list'),
                engines: require('../assets/json/features/engines'),
                cabins: require('../assets/json/features/cabins'),
                anchor_systems: require('../assets/json/features/anchor_systems'),
                roofings: require('../assets/json/features/roofings'),
                navigations: require('../assets/json/features/navigations'),
                deck_floorings: require('../assets/json/features/deck_floorings'),
                bow_thrusters: require('../assets/json/features/bow_thrusters'),
                audios: require('../assets/json/features/audios'),
                lightings: require('../assets/json/features/lightings'),
                boat_gadgets: require('../assets/json/features/boat_gadgets'),

                batman_preview: 'img/batman/batman_boat.png',
                batman_preview_width: '100vw',
                sidebar_position: '-600px',

                dummy_boat: 'img/dummy1.png',
                boat_thumbnail: 'img/boat_cream.png',

                forward_button_text: 'Next option',

                info_modal_active: false,
                info_modal_title: '',
                info_modal_text: '',

                client_email: '',
                email_sent: false,

                custom_email: '',
                custom_name: '',
                custom_tel: '',
                custom_sent: false,

                send_button_active: true,

                more_info_links: [
                    "https://www.lekkerboats.com/engines",
                    "https://www.lekkerboats.com/cabin",
                    "https://www.lekkerboats.com/anchor-system",
                    "https://www.lekkerboats.com/roof-cover",
                    "https://www.lekkerboats.com/console-options",
                    "",
                    "https://www.lekkerboats.com/bow-thruster",
                    "https://www.lekkerboats.com/audio",
                    "",
                    "",
                ]


            }
        },

        mounted: function () {
            if (this.$root.$data.aesthetics) {
                this.boat_thumbnail = this.$root.$data.aesthetics.image;
            }
            this.toggleSidebar();
        },

        computed: {

            isThisActive(l, i) {
                console.log('active');
                return this.lighting_active[i];
            }
        },

        methods: {
            orderCustom: function () {
                this.send_button_active = false;
                this.axios.post('/api/custom', {
                    aesthetics: JSON.stringify(this.$root.$data.aesthetics),
                    features: JSON.stringify(this.$root.$data.features),
                    email: this.custom_email,
                    name: this.custom_name,
                    tel: this.custom_tel
                })
                    .then((response) => {
                        console.log(response.data);
                        this.custom_sent = true;
                        this.send_button_active = true;
			console.log('sending gtag event');
                    	this.$gtm.trackEvent({
                         category: 'FormSentConfigurator',
                         action: 'click',
                         label: 'FormSentConfigurator',
                         value: 1,
                    	});
                    }).catch(
                        console.log('Error sending form data')
                )
            },

            downloadPDF: function () {
                this.send_button_active = false;
                this.axios.post('/api/summary', {
                    aesthetics: JSON.stringify(this.$root.$data.aesthetics),
                    features: JSON.stringify(this.$root.$data.features),
                    email: this.client_email
                })
                    .then((response) => {
                    console.log(response.data);
                    this.email_sent = true;
                    this.send_button_active = true;
		    console.log('sending gtag event');
		    this.$gtm.trackEvent({
		   	 category: 'FormSentConfigurator',
		   	 action: 'click',
		   	 label: 'FormSentConfigurator',
		   	 value: 1,
		    });
                }).catch(function(e){
                    console.log('Error fetching PDF')
                    }
                )
            },
            changeBatmanBoat: function (item) {
                this.batman_preview = item.batman;
            },
            showInfoOverlay: function (item) {
                this.info_modal_title = item.name;
                this.info_modal_text = item.info;
                this.info_modal_active = true;
            },
            checkConfigurationProgress: function () {
                if (this.activeFeature.index === 10) {
                    this.forward_button_text = 'Final summary';
                } else {
                    this.forward_button_text = 'Next option';
                }
            },
            allFeaturesSelected: function () {
                for (let i = 0; i < this.featureCheckStatus.length; i++) {
                    if (!this.featureCheckStatus[i]) {
                        return false;
                    }
                }
                return true;
            },
            toggleFeatureList: function () {
                this.showFeatureList = !this.showFeatureList;
            },
            toggleSidebar: function () {
                if (this.sidebarActive) {
                    this.sidebarActive = false;
                    document.getElementById('sidebar').style.right = '-600px';
                    this.batman_preview_width = '100vw';
                    this.preview_translation = '-50%';
                    this.preview_margin = '50%';
                } else {
                    this.sidebarActive = true;
                    document.getElementById('sidebar').style.right = '-3px';
                    this.batman_preview_width = 'calc(100vw - 600px)';
                    this.preview_translation = '0';
                    this.preview_margin = '0';
                    if (this.showFeatureList) {
                        this.showFeatureList = false;
                    }
                }
            },
            changeActiveFeature: function (feature) {
                this.activeFeature.name = feature.name;
                this.activeFeature.index = feature.index;
                //this.batman_preview = require('../assets/img/batman/' + feature.slug + '.png');
                this.toggleFeatureList();
                if (!this.sidebarActive) {
                    this.toggleSidebar();
                }
                this.checkConfigurationProgress();
                this.batman_preview = 'img/batman/batman_boat.png';
            },
            changeToNextFeature: function () {
                if (this.activeFeature.index === 10) {
                    this.toggleSummary();
                }
                if (this.activeFeature.index >= 1 && this.activeFeature.index <= 9) {
                    this.activeFeature.index += 1;
                    this.activeFeature.name = this.features[this.activeFeature.index - 1].name;
                    this.batman_preview = require('../assets/img/batman/' + this.activeFeature.name.toLowerCase().replace(' ', '_') + '.png');
                }
                this.checkConfigurationProgress();
                this.batman_preview = 'img/batman/batman_boat.png';
            },
            toggleSummary: function () {
                this.showSummary = !this.showSummary;
            },
            changeEngine: function (engine) {
                this.$root.$data.features.engine = engine;
                this.featureCheckStatus[0] = true;
                this.checkConfigurationProgress();
                this.changeBatmanBoat(engine);
            },
            changeCabin: function (cabin, index) {
                this.cabin_active[index] = !this.cabin_active[index];
                if (this.$root.$data.features.cabin[index] === '') {
                    this.$root.$data.features.cabin[index] = cabin;
                } else {
                    this.$root.$data.features.cabin[index] = '';
                }
                this.checkConfigurationProgress();
                this.$forceUpdate();
                this.changeBatmanBoat(cabin);
            },
            changeAnchorSystem: function (anchor_system) {
                this.$root.$data.features.anchor_system = anchor_system;
                this.featureCheckStatus[2] = true;
                this.checkConfigurationProgress();
                this.changeBatmanBoat(anchor_system);
            },
            changeRoofing: function (roofing) {
                this.$root.$data.features.roofing = roofing;
                this.featureCheckStatus[3] = true;
                this.checkConfigurationProgress();
                this.changeBatmanBoat(roofing);
            },
            changeNavigation: function (navigation) {
                this.$root.$data.features.navigation = navigation;
                this.featureCheckStatus[4] = true;
                this.checkConfigurationProgress();
                this.changeBatmanBoat(navigation);
            },
            changeDeckFlooring: function (deck_flooring) {
                this.$root.$data.features.deck_flooring = deck_flooring;
                this.featureCheckStatus[5] = true;
                this.checkConfigurationProgress();
                this.changeBatmanBoat(deck_flooring);
            },
            changeBowThruster: function (bow_thruster) {
                this.$root.$data.features.bow_thruster = bow_thruster;
                this.featureCheckStatus[6] = true;
                this.checkConfigurationProgress();
                this.changeBatmanBoat(bow_thruster);
            },
            changeAudio: function (audio) {
                this.$root.$data.features.audio = audio;
                this.featureCheckStatus[7] = true;
                this.checkConfigurationProgress();
                this.changeBatmanBoat(audio);
            },
            changeLighting: function (lighting, index) {
                this.lighting_active[index] = !this.lighting_active[index];
                if (this.$root.$data.features.lighting[index] === '') {
                    this.$root.$data.features.lighting[index] = lighting;
                } else {
                    this.$root.$data.features.lighting[index] = '';
                }
                this.checkConfigurationProgress();
                this.$forceUpdate();
                this.changeBatmanBoat(lighting);
            },
            changeBoatGadgets: function (gadget, index) {
                this.boat_gadget_active[index] = !this.boat_gadget_active[index];
                if (this.$root.$data.features.boat_gadgets[index] === '') {
                    this.$root.$data.features.boat_gadgets[index] = gadget;
                } else {
                    this.$root.$data.features.boat_gadgets[index] = '';
                }

                this.checkConfigurationProgress();
                this.$forceUpdate();

                if (!this.boat_gadget_active[0] &&
                    !this.boat_gadget_active[1] &&
                    !this.boat_gadget_active[2] &&
                    !this.boat_gadget_active[3] &&
                    !this.boat_gadget_active[4] &&
                    !this.boat_gadget_active[5]) {
                    this.changeBoatGadgets(this.boat_gadgets[5], 5)
                }
                this.changeBatmanBoat(gadget);
            },
            zoomOut: function () {
                if (this.zoomLevel <= this.zoomLevelMin) {

                    this.zoomLevel = this.zoomLevelMin;
                    return;
                }

                this.zoomLevel = (this.zoomLevel * 10 - this.zoomLevelStep * 10) / 10;
            },
            zoomIn: function () {
                if (this.zoomLevel >= this.zoomLevelMax) {

                    this.zoomLevel = this.zoomLevelMax;
                    return;
                }

                this.zoomLevel = (this.zoomLevel * 10 + this.zoomLevelStep * 10) / 10;
            }
        }
    }
</script>
